import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent, IonInput } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  ValidatorsPassword,
  ValidatorsPasswordConfirm,
} from '../../../../../../../helpers/formUtils.helper';
import { ToastService } from '../../../../../../toast.service';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';

@Component({
  selector: 'app-p00045-installation-parametrage-connexion-wifi',
  templateUrl:
    './p00045-installation-parametrage-connexion-wifi.component.html',
  styleUrls: [
    './p00045-installation-parametrage-connexion-wifi.component.scss',
  ],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    LargedLinkComponent,
    FormsModule,
    ReactiveFormsModule,
    IonInput,
    ReactiveFormsModule,
    LabelDescriptionComponent,
  ],
})
export class P00045InstallationParametrageConnexionWIFIComponent
  implements OnInit
{
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  private privateActionStack: DeviceActionStackService | null = null;

  public currentForm: FormGroup | null = null;

  private fb = inject(FormBuilder);
  private edroNetworkManager = inject(EdroNetworkManager);

  private defaultData: any = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );

    this.privateActionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
    );
    this.initForm();
  }

  private initForm() {
    this.defaultData = JSON.stringify({
      ssid: this.actionStack!.getValue('cnINomWifi')?.replace(/\0/g, '').trim(),
      password: this.actionStack!.getValue('cnIMotDePasseWifi')
        ?.replace(/\0/g, '')
        .trim(),
    });

    this.currentForm = this.fb.group({
      ssid: [
        this.actionStack!.getValue('cnINomWifi')?.replace(/\0/g, '').trim() ||
          '',
        [],
      ],
      password: [
        this.actionStack!.getValue('cnIMotDePasseWifi')
          ?.replace(/\0/g, '')
          .trim() || '',
        [],
      ],
    });
  }

  onSubmit() {
    var data = {
      ssid: this.currentForm!.controls['ssid']?.value,
      password: this.currentForm!.controls['password']?.value,
    };

    if (JSON.stringify(data) !== this.defaultData) {
      this.privateActionStack?.editValue(
        P00039DataRxTxIndex.Connect_Installation2,
        'cnINomWifi',
        data.ssid,
      );
      this.privateActionStack?.editValue(
        P00039DataRxTxIndex.Connect_Installation,
        'cnIMotDePasseWifi',
        data.password,
      );
      this.privateActionStack?.commit();
    }

    this.next(this.actionStack!, this.poolAdditionalData!);
  }
}
